
    <ul class="password-requirements-checklist">
      <li [class.met]="hasMinLength"><i class="fa" [ngClass]="hasMinLength ? 'fa-check' : 'fa-times'"></i> At least 8 characters</li>
      <li [class.met]="hasEnoughClasses"><i class="fa" [ngClass]="hasEnoughClasses ? 'fa-check' : 'fa-times'"></i> At least 3 of: uppercase, lowercase, digit, symbol ({{classCount}}/4 so far)</li>
      <li *ngIf="confirmPassword !== undefined && confirmPassword !== null && confirmPassword !== '' && !passwordsMatch">
        <i class="fa fa-times"></i> Passwords don't match yet
      </li>
    </ul>
  